const notWeighedChanged = function () {
  if ($('#scale_not_weighed').is(':checked')) {
    $('.js-scale-parameters').hide();
    $(
      '#scale_minimum_weight, #scale_maximum_weight, #scale_settling_time, #scale_opening_time, #scale_maximum_dosing_time, #scale_discharge_alarm_time'
    ).val('');
  } else {
    $('.js-scale-parameters').show();
  }
};

document.addEventListener('turbolinks:load', function () {
  notWeighedChanged();
  $('#scale_not_weighed').on('change', notWeighedChanged);
});
